import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0104',
    ecrans: ['00-2'],
    params: [
        'id'
    ]
});
